<template>
  <!-- 订货明细 -->
  <div>
    <div class="report_title">
      <label class="report-line" />
      <span class="report-title">历史按购销计划查订货</span>
      <exportConfig
        :all-head="allHead"
        :header-name="headerName"
        :width="'200'"
      />
    </div>
    <el-table
      ref="zTable"
      :data="tableData"
    >
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        fixed
        prop="buyAvgPrice"
        label="采购均价"
      />
      <af-table-column
        fixed
        prop="buyHoldAmount"
        label="采购数量"
      />
      <af-table-column
        prop="buyHoldGainLoss"
        label="采购补充担保履约资金"
      />
      <af-table-column
        prop="sellAvgPrice"
        label="销售均价"
      />
      <af-table-column
        prop="sellHoldAmount"
        label="销售数量"
      />
      <af-table-column
        prop="sellHoldGainLoss"
        label="销售补充担保履约资金"
      />
      <af-table-column
        prop="settlementPrice"
        label="预计报价"
      />
      <af-table-column
        prop="sumFrozenBailBalance"
        label="基本担保履约资金(订货)"
      />
      <af-table-column
        prop="netHoldAmount"
        label="净订单量(笔)"
      />
      <af-table-column
        prop="sumHoldGainLoss"
        label="补充担保履约资金"
      />
    </el-table>
    <MoreData
      :all-data="allData"
      :table-data.sync="tableData"
    />
  </div>
</template>

<script>
import api from '@/api'
import MoreData from '@/components/more-data'
import exportConfig from '@/components/exportConfig'

export default {
  name: 'QueryGoodsCodeHisPositions',
  components: {
    MoreData,
    exportConfig,
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      allHead: [{
        fieldLabel: '购销计划',
        excelColumn: 'goodsCode'
      },
      {
        fieldLabel: '采购均价',
        excelColumn: 'buyAvgPrice'
      },
      {
        fieldLabel: '采购数量',
        excelColumn: 'buyHoldAmount'
      },
      {
        fieldLabel: '采购补充担保履约资金',
        excelColumn: 'buyHoldGainLoss'
      },
      {
        fieldLabel: '销售均价',
        excelColumn: 'sellAvgPrice'
      },
      {
        fieldLabel: '销售数量',
        excelColumn: 'sellHoldAmount'
      },
      {
        fieldLabel: '销售补充担保履约资金',
        excelColumn: 'sellHoldGainLoss'
      },
      {
        fieldLabel: '预计报价',
        excelColumn: 'settlementPrice'
      },
      {
        fieldLabel: '基本担保履约资金(订货)',
        excelColumn: 'sumFrozenBailBalance'
      },
      {
        fieldLabel: '净订单量(笔)',
        excelColumn: 'netHoldAmount'
      },
      {
        fieldLabel: '补充担保履约资金',
        excelColumn: 'sumHoldGainLoss'
      },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,

      tableData: [], // 表格数据
      allData: [],
      headerName: '购销计划一览表_历史按购销计划查订货',
    }
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      }
      param.tradingDate = param.date ? this.$dayjs(this.query.date).format('YYYYMMDD')
        : '' // 默认时间，不附带时间将会返回所有数据，而且连分页都没做
      let res = await api.spotPurchaseSaleInquiry.QueryGoodsCodeHisPositions(param)
      this.allData = res.data || [] ? res.data : []
    },
  }
}

</script>
